import { AdmissionStatus } from './AdmissionStatus';
import {
  authoritativeCandidateCount,
  evidenceReferenceCount,
  supportingDocumentCount,
} from '../../admission/selectors';
import { ADMISSION_READINESS } from '../../admission/labels';

function Metric({ label, value }) {
  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-wide text-eorig-muted">{label}</p>
      <p className="mt-0.5 text-sm font-semibold text-eorig-ink">{value}</p>
    </div>
  );
}

export function AdmissionReadinessCard({ admission }) {
  const status = admission?.readiness_status || ADMISSION_READINESS.NOT_EVALUATED;
  const evaluating = status === ADMISSION_READINESS.EVALUATING;

  return (
    <section
      className="rounded-xl border border-eorig-border bg-white p-4"
      aria-labelledby="admission-readiness-heading"
      aria-busy={evaluating || undefined}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 id="admission-readiness-heading" className="text-sm font-semibold text-eorig-ink">
          Admission readiness
        </h3>
        <AdmissionStatus status={status} />
      </div>
      {evaluating ? (
        <p className="mt-2 text-[13px] text-eorig-muted" role="status">
          Processing admission checks...
        </p>
      ) : (
        <p className="mt-2 text-[12px] text-eorig-muted">
          Readiness means ready for Provider review. It is not Provider approval,
          Custodian authority, or vault admission.
        </p>
      )}
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Metric
          label="Authoritative candidates"
          value={authoritativeCandidateCount(admission)}
        />
        <Metric label="Supporting documents" value={supportingDocumentCount(admission)} />
        <Metric label="Evidence references" value={evidenceReferenceCount(admission)} />
        <Metric
          label="Blockers / warnings"
          value={`${admission?.blocking_count ?? 0} / ${admission?.warning_count ?? 0}`}
        />
      </div>
    </section>
  );
}
